import React, { useContext } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';
import { MessageContext } from '../../contexts/MessageContext';
import { ConditionalRender } from '../formControls';


const audienceTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
        {props.message}
    </Tooltip>
);

const AudienceList = (props) => {

    const context = useContext(AuthContext);

    const showAddAudienceModal = () => {
        const initModel = {
            "message": props.message,
        }
        context.showModal({
            open: true,
            size: 'md',
            model: initModel,
            closeModal: context.hideModal,
            updateCallback: () => props.updateCallback(),
        }, 'addAudienceModal')
    }




    return (
        <div className="message-toolbar d-flex align-items-center">
            <div className="align-items-center mr-auto">
                <ConditionalRender visible={props.message}>
                    <small className="pt-1 pb-1 pr-2 pl-0 mt-2 mb-2 font-weight-bold text-nowrap">Message Audience</small>
                    {
                        props.message?.audience?.map((aud, idx) => {
                            let classname = aud.subscribed ? "audience-item audience-item-subscribed text-nowrap" : "audience-item text-nowrap";
                            return <OverlayTrigger
                                key={idx}
                                placement="bottom-start"
                                delay={{ show: 250, hide: 400 }}
                                overlay={audienceTooltip({ message: aud.subscribed ? 'Following' : 'Not following' })}>
                                <div className={classname}>{aud.user.fullName}</div>
                            </OverlayTrigger>
                        })
                    }
                    <div className="audience-item audience-item-add givemethefinger" onClick={() => showAddAudienceModal()}>Add</div>
                </ConditionalRender>
            </div>
            {props.children ? <div className="card-btn-group">{props.children}</div> : null}
        </div>
    );
}

export default AudienceList;